import { useState, useEffect } from "react";
import "../index.css";
import "../public/Login.css";
import { useSearchParams, useNavigate } from "react-router-dom";
import buttonBackground from "../assets/button_background_blue.webp";
import { BASE_URL } from "../auth/types";

export default function EmailVerificationComplete() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading",
  );
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    const verifyEmail = async () => {
      // Get token from URL query params
      const token = searchParams.get("token");

      if (!token) {
        setStatus("error");
        setMessage("Invalid verification link. No token provided.");
        return;
      }

      try {
        const response = await fetch(
          `${BASE_URL}/accounts/api/email/verify/?token=${encodeURIComponent(token)}`,
          {
            method: "GET",
          },
        );

        if (response.ok) {
          setStatus("success");
          setMessage("Your email has been verified successfully!");
        } else {
          const data = await response.json().catch(() => ({}));
          setStatus("error");
          setMessage(
            data.error ||
              data.message ||
              "Failed to verify email. The link may have expired.",
          );
        }
      } catch {
        //        console.error("Verification error:", error);
        setStatus("error");
        setMessage(
          "An error occurred while verifying your email. Please try again.",
        );
      }
    };

    verifyEmail();
  }, [searchParams]);

  const handleGoToLogin = () => {
    navigate("/login");
  };

  return (
    <div>
      <div className="form-container" style={{ marginTop: 100 }}>
        <div className="form-content">
          <div className="center_me">
            <h2
              className="font_family_base header_text"
              style={{
                fontSize: 28,
                fontWeight: "bold",
                margin: 0,
              }}
            >
              Email Verification
            </h2>
          </div>

          <div
            className="font_family_base"
            style={{
              textAlign: "center",
              marginTop: 30,
              marginBottom: 30,
              lineHeight: 1.6,
            }}
          >
            {status === "loading" && (
              <div>
                <div
                  className="loading-spinner"
                  style={{ margin: "20px auto" }}
                ></div>
                <p style={{ color: "#ccc" }}>Verifying your email...</p>
              </div>
            )}

            {status === "success" && (
              <div>
                <div
                  style={{
                    fontSize: 60,
                    marginBottom: 20,
                  }}
                >
                  ✓
                </div>
                <p
                  style={{ color: "#4ade80", fontSize: 18, fontWeight: "bold" }}
                >
                  {message}
                </p>
                <p style={{ color: "#ccc", marginTop: 15 }}>
                  You can now log in to your account.
                </p>
              </div>
            )}

            {status === "error" && (
              <div>
                <div
                  style={{
                    fontSize: 60,
                    marginBottom: 20,
                  }}
                >
                  ✗
                </div>
                <p style={{ color: "#ff6b6b", fontSize: 18 }}>{message}</p>
                <p style={{ color: "#ccc", marginTop: 15 }}>
                  Please try again or request a new verification email.
                </p>
              </div>
            )}
          </div>

          {status !== "loading" && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <button
                className="my-form-button-wide button-base button-3d font_family_base"
                onClick={handleGoToLogin}
                style={{
                  marginTop: "5px",
                  marginBottom: "15px",
                  backgroundImage: `url(${buttonBackground})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "white",
                  fontWeight: 700,
                }}
              >
                Go to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
